import { recentSearchQueryKeys as e } from "./useRecentSearchQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { recentSearchesApi as n } from "@maat/api-main";
import { useIsAuthenticated as r } from "@maat/store-auth";
import { isRecentSearchLive as i } from "@maat/api-main/types";
import { todayString as a } from "@maat/datetime";
//#region src/recentSearches/useRecentSearchesQuery.ts
var o = (e) => {
	let t = a();
	return { items: e.items.filter((e) => i(e, t)) };
}, s = (i) => {
	let a = r();
	return t({
		queryKey: e.list(i),
		queryFn: () => n.list(i ? { limit: i } : void 0),
		enabled: a,
		staleTime: 6e4,
		select: o
	});
};
//#endregion
export { s as useRecentSearchesQuery };
